module.exports = __webpack_public_path__ + "img/crown.179a9950.png";